import React from 'react'
import { inject, observer } from 'mobx-react'
import { CASE_TYPE_ID, HALL_TYPE_ID, PACKAGE_TYPE_ID } from '../constant'
import { isHotelMerchant } from '@util'
import { Button } from 'hljd'
import Style from './style.module.less'
//案例或套餐或宴会厅的modal
import CaseModal from './CaseModal'
//案例或套餐或宴会厅的list展示
import List from './List'
//原营销工具
import Tool from './Tool'

// todo 现有业务是套餐和宴会厅不会同时出现，部分逻辑有复用，但未来可能三种直播内容并存的情况，届时需要加以拆分

export default inject('store')(
  observer(({ store }) => {
    const IsHotelMerchant = isHotelMerchant() //是否为酒店商家
    const hotelSomeText = (prefix = '') =>
      IsHotelMerchant ? '宴会厅' : prefix + '套餐'
    const {
      packageList,
      caseList = [],
      caseModalStatus,
      changeCaseModal,
      allCaseList,
      saveCase,
      savePackage,
      allPackageList,
      changePackageModal,
      packageModalStatus
    } = store
    const caseIds = caseList.map(item => item.id)
    const packageIds = packageList.map(item => item.id)
    return (
      <div className={Style.videoContent}>
        {/* 套餐 */}
        {!IsHotelMerchant && (
          <div className={`${Style.contentWrap} ${Style.mealContent}`}>
            <div className={Style.title}>
              <span
                style={{
                  display: 'inline-block',
                  width: 56,
                  textAlign: 'right'
                }}
              >
                直播套餐
              </span>
              <div className={Style.info}>
                <p>建议设置1-8个直播活动套餐</p>
                <p>
                  意向金：设置意向金，新人可在直播中直接下单，未设置时新人可以在线预约。
                </p>
                <p>设置的意向金直播期间会同步到全站，直播结束恢复售价。</p>
              </div>
            </div>
            <div style={{ paddingLeft: '86px', marginBottom: '20px' }}>
              <Button
                type="primary"
                onClick={changePackageModal}
                disabled={packageList && packageList.length >= 8}
              >
                添加套餐
              </Button>
            </div>
            <div className={Style.case}>
              <List
                typeId={IsHotelMerchant ? HALL_TYPE_ID : PACKAGE_TYPE_ID}
                list={packageList}
                overflowCount={3}
              />
            </div>
          </div>
        )}

        {/* 宴会厅 */}
        {IsHotelMerchant && (
          <div className={Style.contentWrap}>
            <div className={Style.title}>
              <span
                style={{
                  display: 'inline-block',
                  width: 56,
                  textAlign: 'right'
                }}
              >
                宴会厅
              </span>
              <Button
                type="primary"
                onClick={changePackageModal}
                disabled={packageList && packageList.length >= 8}
              >
                添加宴会厅
              </Button>
              <div className={Style.info}>建议设置1-8个直播活动宴会厅</div>
            </div>
            <div className={Style.case}>
              <List
                typeId={IsHotelMerchant ? HALL_TYPE_ID : PACKAGE_TYPE_ID}
                list={packageList}
                overflowCount={3}
              />
            </div>
          </div>
        )}
        <CaseModal
          visibility={packageModalStatus}
          onCancel={changePackageModal}
          allList={allPackageList}
          onOk={savePackage}
          checkList={packageIds}
          title={'选择' + hotelSomeText()}
          emptyDesc={`还没有${hotelSomeText()}哦，快去上传${hotelSomeText()}吧~`}
        />
        {/* 案例(酒店商家无此项) */}
        {!IsHotelMerchant && (
          <div className={Style.contentWrap}>
            <div className={Style.title}>
              直播案例
              <Button
                type="primary"
                onClick={changeCaseModal}
                disabled={caseList && caseList.length >= 8}
              >
                添加案例
              </Button>
              <div className={Style.info}>建议设置1-8个案例</div>
            </div>
            <div className={Style.case}>
              <List typeId={CASE_TYPE_ID} list={caseList} overflowCount={3} />
            </div>
            <CaseModal
              visibility={caseModalStatus}
              onCancel={changeCaseModal}
              allList={allCaseList}
              onOk={saveCase}
              checkList={caseIds}
              title="选择案例"
              emptyDesc="还没有案例哦，快去上传案例吧~"
            />
          </div>
        )}

        {/* 原营销工具 */}
        <Tool />
      </div>
    )
  })
)
